module.exports = __webpack_public_path__ + "img/charge_status_99.0de6f93e.png";